import { FolderAddOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useAuthContext } from 'contexts/AuthContext';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AccessType } from 'types/User';
import AjoutDossierForm from 'views/dossiers/ajout/AjoutDossierForm';

const NewDossierButton: React.FC = () => {
  const { t } = useTranslation();
  const { auth } = useAuthContext();
  const [openRequestId, setOpenRequestId] = useState(0);

  const isConcessionnaire =
    auth?.user?.accessType === AccessType.CONCESSIONNAIRE;
  const isSimulateur = auth?.user?.accessType === AccessType.SIMULATEUR;
  const isClient = auth?.user?.accessType === AccessType.CLIENT;

  const handleOpenModal = () => {
    setOpenRequestId((previous) => previous + 1);
  };

  const buttonContent = (
    <Button
      type="primary"
      size="large"
      shape="round"
      icon={<FolderAddOutlined />}
      onClick={isClient ? handleOpenModal : undefined}
    >
      {isSimulateur
        ? t('global:calculer_ma_prime')
        : t('global:soumettre_un_dossier')}
    </Button>
  );

  if (isClient) {
    return (
      <>
        {buttonContent}
        <AjoutDossierForm openRequestId={openRequestId} />
      </>
    );
  }

  return (
    <Link
      to={
        isSimulateur
          ? '/calculer-prime'
          : isConcessionnaire
            ? '/nouveau-dossier-concessionnaire/etape-1'
            : '#'
      }
    >
      {buttonContent}
    </Link>
  );
};

export default NewDossierButton;
